import Vue from "vue";
import Vuex from "vuex";
import VeeValidate from "vee-validate";

import { alert } from "./alert.module";
import { AOIanalysis } from "./aoi-report.module";
import { authentication } from "./auth.module";
import { users } from "./users.module";
import { project } from "./project.module";
import { image } from "./image.module";
import { report } from "./report.module";
import { auth } from "./auth.module";

//  modals
import { dialogModal } from "./dialog-modal.module";

Vue.use(Vuex);
// Vue.use(VeeValidate);

Vue.use(VeeValidate, {
  errorBagName: "vErrors"
});

export const store = new Vuex.Store({
  modules: {
    alert,
    AOIanalysis,
    authentication,
    users,
    project,
    image,
    report,
    dialogModal
    // auth
  }
});
